import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const EyeIcon = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 14 8'
  fill='none'
  {...props}
>
  <Path
    d='M7.00113 0C3.26943 0 0.426317 3.73246 0.426317 3.73246C0.303207 3.88884 0.303207 4.11197 0.426317 4.26827C0.426317 4.26827 3.26943 8 7.00113 8C10.7328 8 13.575 4.26827 13.575 4.26827C13.6981 4.11189 13.6981 3.88876 13.575 3.73246C13.575 3.73246 10.7328 0 7.00113 0ZM7.00113 1.73248C8.21837 1.73248 9.21496 2.75313 9.21496 3.99999C9.21496 5.24675 8.21847 6.26835 7.00113 6.26835C5.78388 6.26835 4.78646 5.24685 4.78646 3.99999C4.78646 2.75323 5.78378 1.73248 7.00113 1.73248Z'
    fill='#8AB2D9'
  />
</Svg>;

export default EyeIcon;
